import { cloneDeep } from 'lodash';

import {
    ADD_REPORT_DOMAIN,
    CHANGE_REPORTS_DOMAIN_COLUMNS_VISIBILITY,
    CHANGE_REPORTS_DOMAIN_GRID_ORDER,
    FETCH_REPORTS_DOMAIN,
    ReportsDomainAction,
    STOP_REPORTS_DOMAIN_LOADING,
    UPDATE_COLUMNS_SETTINGS_REPORTS_DOMAIN_STATE,
    UPDATE_REPORTS_DOMAIN,
    UPDATE_REPORTS_DOMAIN_COLUMNS_WIDTH
} from '../actions/reportsDomain';
import { getColumnsSettings } from '../declarations/common';
import { reportsDomain } from '../typings/common';
import { ReportsDomainState } from '../typings/state';

export const ReportsDomainInitialState: ReportsDomainState = {
    columnsSettings: getColumnsSettings(),
    loading: false
};

export function reportDomain(
    state: ReportsDomainState = ReportsDomainInitialState,
    action: ReportsDomainAction
): ReportsDomainState {
    switch (action.type) {
        case FETCH_REPORTS_DOMAIN:
            return {
                ...state,
                loading: true
            };
        case UPDATE_REPORTS_DOMAIN:
            return {
                ...state,
                reportsDomain: cloneDeep(action.reportsDomain),
                loading: false
            };
        case ADD_REPORT_DOMAIN:
            return {
                ...state,
                periodValue: action.period,
                loading: true
            };
        case UPDATE_REPORTS_DOMAIN_COLUMNS_WIDTH:
            return {
                ...state,
                columnsSettings: cloneDeep(action.columns)
            };
        case CHANGE_REPORTS_DOMAIN_GRID_ORDER:
            return {
                ...state,
                columnsSettings: {
                    ...state.columnsSettings,
                    [reportsDomain]: {
                        ...state.columnsSettings[reportsDomain],
                        columnOrder: action.columnOrder
                    }
                }
            };
        case CHANGE_REPORTS_DOMAIN_COLUMNS_VISIBILITY:
            return {
                ...state,
                columnsSettings: cloneDeep(action.columns)
            };
        case STOP_REPORTS_DOMAIN_LOADING:
            return {
                ...state,
                loading: false
            };
        case UPDATE_COLUMNS_SETTINGS_REPORTS_DOMAIN_STATE:
            return {
                ...state,
                columnsSettings: cloneDeep(action.columnsSettings)
            };
        default:
            return state;
    }
}
